export const BRAND_PATH_PREFIX = 'https://dam.malt.com/brand/';
export const BRAND_ILLUSTRATIONS_PATH_PREFIX = `${BRAND_PATH_PREFIX}illustrations/`;

export function getBrandIllustration(name) {
    return `${BRAND_ILLUSTRATIONS_PATH_PREFIX}${name}`;
}
